import { Fetch } from 'lib';
import type { PageSettingCode } from 'types';

type RequestResponses = {};

type RequestParameters = {};

type RequestBody = {
  code: PageSettingCode;
  title: string;
  categoriesIds: string[];
};

const updatePageCategoryProducts = async (body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminPageBuilder/updatePageCategoryProducts',
    method: 'PATCH',
    body,
  });

export { updatePageCategoryProducts };
